import BaseValidator from '@/app-core/lib/data/validator/BaseValidator'

export default class CheckoutAddressValidator extends BaseValidator {
  validatorRules = {
    Id: {
      required: false,
      type    : BaseValidator.Type.Number
    },
    AutoComplete: {
      requiredIf: ['useCustomAddress', false],
      limits    : (value, model) => {
        return !!model?.Formatted
      }
    },
    City: {
      required: true,
      type    : BaseValidator.Type.String,
      minLen  : 2,
      maxLen  : 120
    },
    Postcode: {
      required: true,
      type    : BaseValidator.Type.String,
      minLen  : 2,
      maxLen  : 10
    },
    Street: {
      required: true,
      type    : BaseValidator.Type.String,
      minLen  : 2,
      maxLen  : 120
    },
    Number: {
      required: true,
      type    : BaseValidator.Type.String,
      minLen  : 1,
      maxLen  : 10
    }
  }

  validatorMessages = {
    el: {
      limits: 'Η διεύθυνση πρέπει να είναι μέσα στα όρια διανομής'
    },
    en: {
      limits: 'Address must be within delivery area'
    }
  }

  constructor(data = {}) {
    super(data)
  }
}
